export default __webpack_public_path__ + "static/logo-header-black-fb22848997353c9ed695a5a66c030a4c.png";